import { useContext } from "react";
import {
  CustomButton2,
  CustomInput,
  CustomModal,
  CustomView,
} from "../../../../../../components";
import "./index.scss";
import Context from "../../../../../../context";
import { useFormik } from "formik";
import validations from "../../../../../../validations";
import * as Yup from "yup";
import utils from "../../../../../../utils";
import Cookies from "js-cookie";
import constants from "../../../../../../values/constants";
import { useTranslation } from "react-i18next";

const Request = () => {
  const { setShowModal, showModal, onSubmitRequest, isLoading } = useContext(
    Context.WithdrawalScreen
  );

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );
  const { userInfo } = useContext(Context.UserScreen);

  const formik = useFormik({
    initialValues: {
      amount: "",
      bankName: "",
      bankId: userInfo?.financial?.kartNumber,
      shabaId: userInfo?.financial?.shabaNumber,
    },
    validationSchema: Yup.object({
      amount: validations.yupValidations.price,
      bankId: Yup.string()
        .matches(/^\d{16}$/, "شماره کارت را به درستی وارد کنید")
        .required("این فیلد اجباری است"),
      shabaId: Yup.string()
        .matches(/^\d{22}$/, "شماره شبا را به درستی وارد کنید")
        .required("این فیلد اجباری است"),
    }),
    onSubmit: (values) => {
      //console.log(values);
      onSubmitRequest({
        ...values,
        amount: utils.convertPriceToNumber(values?.amount as string).toString(),
      });
    },
  });

  const { t } = useTranslation();

  const balance = Math.floor(Number(Cookies.get(constants.USER.BALANCE)));

  return (
    <div className="request-button">
      {userType === "COMPANY" && (
        <>
          <CustomButton2
            minWidth={"5rem"}
            title={"withDrawalRequest"}
            type="info"
            leftIcon=""
            onClick={() => setShowModal("REQUEST")}
          />
          <CustomModal
            onClose={() => setShowModal("NONE")}
            open={showModal === "REQUEST"}
            maxWidth={"40vw"}
          >
            <form onSubmit={formik.submitForm}>
              <CustomView.Container>
                <CustomView.Row>
                  <div className="balance-container">
                    <span>{t("totalBalance")}: </span>
                    <strong>{utils.convertNumberToPrice(balance)}</strong>
                    <strong> {t("toman")}</strong>
                  </div>
                </CustomView.Row>
                <CustomView.Row>
                  <CustomView.Column medium={6}>
                    <CustomView.Row className="request-amount">
                      <CustomView.Column medium={7}>
                        <CustomInput
                          name="amount"
                          id="amount"
                          value={
                            utils.convertPriceToNumber(
                              formik.values.amount as string
                            )
                              ? utils.convertNumberToPrice(
                                  utils.convertPriceToNumber(
                                    formik.values.amount as string
                                  )
                                )
                              : formik.values.amount?.slice(0, -1)
                          }
                          onValueChange={formik.handleChange}
                          formikProps={{ onBlur: formik.handleBlur }}
                          error={formik.errors.amount && formik.touched.amount}
                          errorText={formik.errors.amount}
                          label={t("amount")}
                        />
                      </CustomView.Column>
                      <CustomView.Column className="button-request" medium={4}>
                        <CustomButton2
                          onClick={() =>
                            formik.setFieldValue(
                              "amount",
                              utils.convertNumberToPrice(balance)
                            )
                          }
                          type="primary"
                          title={t("maximum")}
                        />
                      </CustomView.Column>
                    </CustomView.Row>
                  </CustomView.Column>
                  <CustomView.Column medium={6}>
                    <CustomInput
                      name="bankName"
                      id="bankName"
                      value={formik.values.bankName}
                      onValueChange={formik.handleChange}
                      formikProps={{ onBlur: formik.handleBlur }}
                      error={formik.errors.bankName && formik.touched.bankName}
                      errorText={formik.errors.bankName}
                      label={t("bankName")}
                    />
                  </CustomView.Column>{" "}
                  <CustomView.Column medium={6}>
                    <CustomInput
                      name="bankId"
                      id="bankId"
                      value={formik.values.bankId}
                      onValueChange={formik.handleChange}
                      formikProps={{ onBlur: formik.handleBlur }}
                      error={formik.errors.bankId && formik.touched.bankId}
                      errorText={formik.errors.bankId}
                      label={t("cardNumber")}
                    />
                  </CustomView.Column>{" "}
                  <CustomView.Column medium={6}>
                    <CustomInput
                      name="shabaId"
                      id="shabaId"
                      value={formik.values.shabaId}
                      onValueChange={formik.handleChange}
                      formikProps={{ onBlur: formik.handleBlur }}
                      error={formik.errors.shabaId && formik.touched.shabaId}
                      errorText={formik.errors.shabaId}
                      isShaba
                      label={t("shabaNumber")}
                      maxLength={22}
                    />
                  </CustomView.Column>
                  <CustomView.Column className="button-request" medium={6}>
                    <CustomButton2
                      onClick={formik.submitForm}
                      type="success"
                      title={t("submit")}
                      isLoading={isLoading}
                    />
                  </CustomView.Column>
                </CustomView.Row>
              </CustomView.Container>
            </form>
          </CustomModal>
        </>
      )}
    </div>
  );
};

export default Request;
